import { PaymentReviewRecordsFilters } from "@/api/backofficeRest/generated/model"
import { formatServerDate, formatServerDateTime } from "@/helpers/dateHelper"
import { PaymentReviewRecordFilters } from "@/services/operations/PaymentReviewService"

export function serializeFilters(
  paymentReviewId: number,
  filters: PaymentReviewRecordFilters,
): PaymentReviewRecordsFilters {
  return {
    paymentReviewId: paymentReviewId.toString(),
    changedAmountMax: filters.changedAmountMax?.toString(),
    changedAmountMin: filters.changedAmountMin?.toString(),
    errorCodes: filters.errorCodes?.length ? filters.errorCodes : undefined,
    from: formatServerDateTime(filters.from) ?? undefined,
    to: formatServerDateTime(filters.to) ?? undefined,
    nextPaymentDateFrom:
      formatServerDate(filters.nextPaymentDateFrom) ?? undefined,
    nextPaymentDateTo: formatServerDate(filters.nextPaymentDateTo) ?? undefined,
    status: filters.status ?? undefined,
  }
}
